module.exports = __webpack_public_path__ + "img/2w.58b6fadc.png";